module.exports = __webpack_public_path__ + "static/img/icon_smallscreen.6ecd3d91.svg";